






import Vue from 'vue'
import Component from 'vue-class-component'
import Status from './Status.vue'
import { EPaymentStatus } from '@zunta/configurations'
import { EStatusType } from '@/components/statuses/EStatusType'
import { PAYMENT_STATUSES_LABEL_MAP } from '@/constants'

@Component({
  components: { Status },
  props: {
    status: {
      status: String,
      required: true
    }
  }
})
export default class StatusPayment extends Vue {
  get type (): EStatusType {
    if (!this.$props.status) {
      return EStatusType.default
    }
    switch (this.$props.status) {
      case EPaymentStatus.APPROVED:
        return EStatusType.success
      case EPaymentStatus.PENDING:
      case EPaymentStatus.PENDING_APPROVAL:
      case EPaymentStatus.UPCOMING:
        return EStatusType.pending
      case EPaymentStatus.REFUNDED:
      case EPaymentStatus.SKIPPED:
      case EPaymentStatus.VOIDED:
      case EPaymentStatus.PARTIALLY_REFUNDED:
        return EStatusType.process
      case EPaymentStatus.CHARGEBACK:
        return EStatusType.attention
      case EPaymentStatus.DECLINED:
        return EStatusType.error
      default:
        return EStatusType.default
    }
  }

  get text (): string {
    if (!this.$props.status) {
      return ''
    }

    return PAYMENT_STATUSES_LABEL_MAP[this.$props.status]
  }
}
